
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Release, getPastReleases } from 'api/releases';
import { Meta } from 'components/common/Meta';
import { ReleaseCalendar } from 'components/release-calendar/ReleaseCalendar';
import { ReleasePage, getServerSideProps as getReleaseServerSideProps, } from 'components/release-calendar/pages/release';
import routes from 'constants/routes';
import { ReleaseCalendarProvider } from 'contexts/providers/ReleaseCalendarProvider';
import { BaseLayout } from 'layouts/BaseLayout';
import { GetServerSideProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { flatCollectionType } from 'utils/data';
import { getReleaseUrl } from 'utils/urls';
type Props = {
    isReleaseCalendarPage?: boolean;
    release?: Release;
    pastReleases?: Release[];
};
const SlugPage = (props: Props) => {
    const { t } = useTranslation();
    if (props.isReleaseCalendarPage) {
        const { release, pastReleases } = props;
        const artworkName = release?.artwork?.data?.attributes?.name || '';
        const artworkImage = release?.artworkImages?.data?.find(image => image.attributes.name?.includes('(2)')) || release?.artworkImages?.data?.[0];
        const flatArtworkImage = artworkImage
            ? flatCollectionType(artworkImage)
            : undefined;
        return (<>
        {!release && (<Meta pageTitle={t('release_calendar:page_title')} pageDescription={t('release_calendar:page_description')} relativeUrl={routes.releaseCalendar.base} imageName='release_calendar:calendar-social-image'/>)}

        {release && (<>
            <Head>
              <style>
                {`body {
                  overflow: hidden;
                  position: fixed;
                }`}
              </style>
            </Head>

            <Meta pageTitle={t('release_calendar:release_page_title', {
                    releaseName: release.name || '',
                    artistName: release.artists?.data?.[0]?.attributes?.name || '',
                    medium: release.medium || ''
                })} pageDescription={t('release_calendar:release_page_description', {
                    artworkName
                })} relativeUrl={getReleaseUrl(release.id, release.name || '', release.artists?.data?.map(artist => ({
                    id: artist.id,
                    name: artist.attributes?.name || ''
                })) || [], release.extraArtists)}>
              {flatArtworkImage?.url && (<meta name='og:image' content={flatArtworkImage.url}/>)}
            </Meta>
          </>)}

        <BaseLayout>
          <ReleaseCalendarProvider initialPastReleases={pastReleases}>
            <ReleaseCalendar>
              {release && <ReleasePage release={release}/>}
            </ReleaseCalendar>
          </ReleaseCalendarProvider>
        </BaseLayout>
      </>);
    }
    return null;
};
const getServerSideProps: GetServerSideProps<Props> = async (context) => {
    const { slug } = context.query;
    if (!slug)
        return { notFound: true };
    if (slug[0] === routes.releaseCalendar.base.replace('/', '')) {
        const release = slug[1];
        if (release) {
            return await getReleaseServerSideProps(context);
        }
        // cache for 1 hour with swr 24hours
        context.res.setHeader('Cache-Control', `public, s-maxage=${1 * 60 * 60}, stale-while-revalidate=${24 * 60 * 60}`);
        const { data: rawPastReleases } = await getPastReleases({
            pagination: { pageSize: 6 }
        });
        const pastReleases = rawPastReleases.map(flatCollectionType);
        return { props: { isReleaseCalendarPage: true, pastReleases } };
    }
    return {
        notFound: true
    };
};
export default SlugPage;

    async function __Next_Translate__getServerSideProps__19bb23d2d34__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[...slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__19bb23d2d34__ as getServerSideProps }
  